import { DateTime } from 'luxon';
import type { AccreditationRejectionReasonCode } from '../accreditation-rejection-reasons.types';
import {
  AccreditationState,
  AccreditationType,
  RawAccreditationData,
} from '../../../../services/accreditations-service.types';

export type AccreditationDetailProps = {
  flexWorkerId: string;
  certificateId: string;
  accreditationType: AccreditationType;
  close: () => void;
};

export type AccreditationDetailCommonProps = {
  data: RawAccreditationData;
  closeModal: () => void;
};

export type AccreditationDetailFormValues = {
  expirationDate?: string;
  rejectionReason: AccreditationRejectionReasonCode | '';
};

const accreditationStatesWithRejectionReason: AccreditationState[] = [
  'pending',
  'verified',
  'rejected',
  'all',
];

export const showsRejectionReasonField = (state: AccreditationState) =>
  accreditationStatesWithRejectionReason.includes(state);

export const isRejectionReasonRequired = (state: AccreditationState) =>
  accreditationStatesWithRejectionReason.includes(state);

export type AccreditationDetailButtonBaseProps = {
  flexWorkerId: RawAccreditationData['flexWorkerId'];
  certificateId: RawAccreditationData['certificateId'];
  accreditationType: RawAccreditationData['type'];
  closeModal: () => void;
};

export type UpdateAccreditationButtonProps = AccreditationDetailButtonBaseProps & {
  expirationDate: DateTime | null;
  startDate: DateTime | null;
  accreditationState: AccreditationState;
  rejectionReason: AccreditationDetailFormValues['rejectionReason'];
};

export type ApproveAccreditationButtonProps = AccreditationDetailButtonBaseProps & {
  expirationDate: DateTime | null;
};

export type RejectAccreditationButtonProps = AccreditationDetailButtonBaseProps & {
  rejectionReason: AccreditationDetailFormValues['rejectionReason'];
};

export type ButtonsBasedOnAccreditationStateProps = {
  accreditationState: AccreditationState;
  flexWorkerId: RawAccreditationData['flexWorkerId'];
  certificateId: RawAccreditationData['certificateId'];
  accreditationType: RawAccreditationData['type'];
  expirationDate: DateTime | null;
  startDate: DateTime | null;
  rejectionReason: AccreditationDetailFormValues['rejectionReason'];
  closeModal: () => void;
};
